import React from "react";

export default function DiscordEmbedPreview({
  color = "#4a0e17",
  title,
  descriptionHtml,
  thumbnailUrl,
  showThumbnail = false,
  imageUrl,
  footerHtml,
  showTimestamp = false,
  mention,
  children,
  className = "",
}) {
  return (
    <div className={`discord-preview-stack ${className}`.trim()}>
      {mention && (
        <div className="discord-content-ping">
          <span className="mention">{mention}</span>
        </div>
      )}
      <div className="discord-mockup" style={{ borderLeftColor: color }}>
        <div className="embed-body">
          <div className="embed-content">
            {title ? <div className="embed-title">{title}</div> : null}
            {descriptionHtml ? (
              <div
                className="embed-description"
                dangerouslySetInnerHTML={{ __html: descriptionHtml }}
              />
            ) : null}
          </div>
          {showThumbnail && thumbnailUrl ? (
            <img src={thumbnailUrl} alt="" className="preview-avatar" />
          ) : null}
        </div>
        {imageUrl ? (
          <img
            src={imageUrl}
            alt=""
            className="preview-embed-image"
            referrerPolicy="no-referrer"
          />
        ) : null}
        {(footerHtml || showTimestamp) && (
          <div className="discord-footer">
            {footerHtml ? (
              <span
                className="footer-text"
                dangerouslySetInnerHTML={{ __html: footerHtml }}
              />
            ) : null}
            {footerHtml && showTimestamp ? (
              <span className="footer-separator">•</span>
            ) : null}
            {showTimestamp ? (
              <span className="footer-date">Today at 4:20 PM</span>
            ) : null}
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
